import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from '~/Locale';
import Section from '~/App/shared/components/Layout/Section';
import EmailVerificationForm, {
  EmailSubmit
} from './components/EmailVerificationForm';
import EmailVerificationSubmit from './components/EmailVerificationSubmit';
import { session as sessionSelector } from '~/App/shared/selectors/sessionSelector';
import {
  RegistrationBox,
  RegistrationContainer,
  RegistrationContent,
  RegistrationFormContainer,
  RegistrationHeading
} from '~/App/shared/components/Auth/Registration/components/RegistrationElements';
import Content from '~/App/shared/components/Layout/Content';
import { useLocation } from 'react-router';

const EmailVerificationHandler = () => {
  const { t } = useTranslation();
  const session = useSelector(sessionSelector);
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const token = searchParams.get('token') ?? '';

  return (
    <Content>
      <Section backgroundColor="light">
        <RegistrationContainer>
          <RegistrationBox>
            <RegistrationContent>
              <RegistrationHeading>{t('Almost there!')}</RegistrationHeading>
              <RegistrationFormContainer>
                <EmailVerificationSubmit token={token}>
                  {(submit: EmailSubmit) => (
                    <EmailVerificationForm
                      token={token}
                      submit={submit}
                      session={session}
                    />
                  )}
                </EmailVerificationSubmit>
              </RegistrationFormContainer>
            </RegistrationContent>
          </RegistrationBox>
        </RegistrationContainer>
      </Section>
    </Content>
  );
};

export default EmailVerificationHandler;
